import { ColumnResizer } from './ColumnResizer';

/** A resizable VALUE/CODE sub-column header with a drag handle on its right edge. */
export function SubHeaderCell({
  label,
  width,
  readOnly,
  isLast,
  onLive,
  onCommit,
  col,
}: {
  label: string;
  width: number;
  readOnly: boolean;
  isLast?: boolean;
  onLive: (w: number) => void;
  onCommit: (w: number) => void;
  col: number;
}) {
  return (
    <th
      data-col={col}
      className={`relative select-none border-b border-l border-border-light bg-muted px-2 py-1.5 text-left text-[10px] font-semibold uppercase tracking-wide text-muted-foreground ${
        isLast ? 'border-r' : ''
      }`}
    >
      {label}
      {!readOnly && <ColumnResizer width={width} onLive={onLive} onCommit={onCommit} />}
    </th>
  );
}
